import {React, useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function WorkspaceBanner(){

    useEffect(()=>{
        AOS.init({duration:1000});
      }, [])

    return (
        <div className="planning-background  font-[lato] text-white my-20" data-aos="fade-up">
            <div className="max-w-xl md:ml-16 py-10">
                <h1 className="text-[38px] font-semibold py-5">Planning your next workspace?</h1>
                <p className="text-[16px]">We shape new office strategies, help you select the right locations and share space options to better support your business goals. </p>
            </div>
        </div>
    )
}


export default WorkspaceBanner